import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { formatDate, formatDateTime } from 'utils/Formatters';
import { find, isEmpty, map, groupBy } from 'lodash';

class GroupCohortsReportDetailsModal extends React.Component {
  render() {
    const {report} = this.props;

    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>{this.props.t('reports.details.title')}</b></h2>
        <hr className='u-margin-top--zero'/>
        <table className='o-table o-table--bordered'>
          <tbody>
            <tr>
              <th>{this.props.t('reports.details.requestedAt')}</th>
              <td>{formatDateTime(report.createdAt)}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.groups')}</th>
              <td>{this.renderRelated('groups')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.withCohorts')}</th>
              <td>{report.params.withcohorts ? this.props.t('reports.details.yes') : this.props.t('reports.details.no')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.withAgeRanges')}</th>
              <td>{report.params.withages ? this.props.t('reports.details.yes') : this.props.t('reports.details.no')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderRelated(related) {
    const collection = this.props[related];

    return this.relatedIds(related).map((id) => {
      return find(collection, p => p.value == id).label;
    }).join(', ');
  }

  relatedIds(relatedAttribute) {
    const {report} = this.props;

    if (isEmpty(report.params[relatedAttribute])) { return []; }

    return report.params[relatedAttribute].split(',').map((id) => {
      return parseInt(id, 10);
    });
  }
}

const mapStateToProps = (state) => {
  return {
    groups: state.filters.groups,
  };
}

GroupCohortsReportDetailsModal.propTypes = {
  report: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default connect(mapStateToProps, null)(withTranslation()(GroupCohortsReportDetailsModal));
